/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
export default function T6Animated(props) {
  const pause = React.useRef(false);
  let timer = 0;

  React.useEffect(() => {
    const closeButton = document.getElementById("excercise-close-button"); // lấy từ component ExcerciseModal
    closeButton.addEventListener("click", stopAudio);
    getElement();
    return () => closeButton.removeEventListener("click", stopAudio);
  });

  const stopAudio = () => {
    pause.current = true;
  };

  const getElement = async () => {
    let audio1 = document.getElementById("audio1");
    let audio2 = document.getElementById("audio2");
    let audio3 = document.getElementById("audio3");

    let spanText1 = document.querySelectorAll("#span-text");
    let spanText2 = document.querySelectorAll("#span-text2");
    let spanText3 = document.querySelectorAll("#span-text3");

    let image1 = document.getElementById("image1");
    let image2 = document.getElementById("image2");
    let image3 = document.getElementById("image3");

    let maximum2 = 180;
    let maximum3 = 70;

    // gọi hàm
    await leftToRight(image1, spanText1, audio1); // đoạn 1

    await delay(8000);
    await RightToLeft(image2, spanText2, audio2, maximum2); // đoạn 2

    await delay(5000);
    await RightToLeft(image3, spanText3, audio3, maximum3); // đoạn 3
  };

  //  hình 1 đoạn 1
  async function leftToRight(image, spanText, audio) {
    let left = 0;
    let opacity = 0;
    await delay(2000);

    let timer = setInterval(async () => {
      if (opacity <= 1) {
        image.style.opacity = opacity + 0.1;
        opacity += 0.1;
      }

      if (left < 210) {
        image.style.transition = "all 0.5s";
        image.style.left = left + "px";
        left += 10;
      }

      if (left === 200) {
        clearInterval(timer);

        await delay(1000);
        if (pause.current === false) {
          audio.play();
          let parenDiv = spanText[0].parentElement;
          parenDiv.style.border = "1px solid black";
          parenDiv.style.backgroundColor = "white";

          for (let i = 0; i < spanText.length; i++) {
            spanText[i].style.display = "unset";
            await delay(200);
            console.log("leftToRight");
          }
        } else {
          audio.pause();
        }
      }
    }, 100);
  }

  //  hình 2-3 đoạn 2-3
  async function RightToLeft(image, spanText, audio, maximum) {
    let right = 0;
    let opacity = 0;

    timer = setInterval(async () => {
      if (opacity <= 1) {
        image.style.opacity = opacity + 0.1;
        opacity += 0.1;
      }

      if (right < 210) {
        image.style.transition = "all 0.5s";
        image.style.right = right + "px";
        right += 10;
      }

      if (right === maximum) {
        clearInterval(timer);
        await delay(1000);
        if (pause.current === false) {
          audio.play();

          let parenDiv = spanText[0].parentElement;
          parenDiv.style.border = "1px solid black";
          parenDiv.style.backgroundColor = "white";

          for (let i = 0; i < spanText.length; i++) {
            spanText[i].style.display = "unset";
            await delay(200);
            console.log("RightToLeft");
          }
        } else {
          audio.pause();
        }
      }
    }, 100);
  }

  async function delay(second) {
    return new Promise((resolve) => setTimeout(resolve, second));
  }

  return (
    <div style={{ position: "absolute", top: 309, left: 639, zIndex: 100 }}>
      {/* <img  src="/img/FriendsPlus/Page6/Demo/a.png" width={140} alt="" /> */}
      <audio id="audio1" src="/Audios/Giọng Nam.mp3"></audio>
      <audio id="audio2" src="/Audios/Giọng Mai.mp3"></audio>
      <audio id="audio3" src="/Audios/Giọng rô bốt.mp3"></audio>
    </div>
  );
}
